<script>
  export default {
    name: 'FabricSectionGroup',
    props: {
      id: {
        type: [String, Number],
        default: (() => Math.floor(Math.random() * 100)),
      },
    },
  }
</script>

<template>
  <section 
    :id="id + '__fb_sectionGroup__'" 
    class="input-group">
    <slot name="prepend" />
    <slot/>
    <slot name="append" />
  </section>
</template>
